import { useEffect } from "react";
import { Link } from "react-router";
import { useNavigate } from "react-router";

import { Column, TopbarContainer, TopbarTitle } from "@/components";
import { SignupVariantsForm } from "@/components/tools/SignupVariantsForm";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS, MIXPANEL_SUBSCREENS } from "@/lib/mixpanel/types";
import { novaClient } from "@/lib/trpc";
import { CreateOrUpdateSignupVariantRequest } from "@/types";

export const ToolsSignupVariantsCreatePage = () => {
  const navigate = useNavigate();

  const { mutate: createSignupVariant, isPending } =
    novaClient.internal.admin.dynamicPageVariants.create.useMutation({
      onSuccess: () => {
        void navigate("/tools/signup-variants");
      },
    });

  useSetTitle({
    title: "Tools | Signup Variants | Create",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.SIGNUP_VARIANTS, {
      subScreenName: MIXPANEL_SUBSCREENS.CREATE,
    });
  }, []);

  const handleSubmit = (data: CreateOrUpdateSignupVariantRequest) => {
    createSignupVariant({ ...data });
  };

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle className="!text-slate-500">
          <Link className="hover:underline" to="/tools/signup-variants">
            Signup Variants
          </Link>{" "}
          / <span className="text-slate-700">Create</span>
        </TopbarTitle>
      </TopbarContainer>
      <div className="flex-1 overflow-hidden">
        <SignupVariantsForm
          isSubmitting={isPending}
          onSubmit={handleSubmit}
          submitButtonText="Create"
        />
      </div>
    </Column>
  );
};
